// @flow
import FFRtvHub from 'components/FFRtv/FFRtvHub';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/FFRtv/FFRtvHub';
import { fetchYoutubePosts } from 'actions/youtubeActions';
import { STATUS_SUCCESS, STATUS_LOADING } from 'constants/statusConstants';

export default connect(
  (state: StateType): StateProps => ({
    posts: [...state.youtubeState.posts],
    status: state.youtubeState.status === STATUS_SUCCESS ? STATUS_SUCCESS : STATUS_LOADING,
    titleLigue: state.settingsState.title
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchYoutubePosts: () => dispatch(fetchYoutubePosts())
  })
)(FFRtvHub);
